import React, { useRef, useEffect, useState } from 'react';
import { isInViewport } from '../_helpers';
import styled from 'styled-components';

const RevealerFade = styled.div`
  position: relative;
  width: 100%;
  opacity: ${props => props.isRevealed ? 1 : 0};
  transition: all ${props => props.speed ? `${props.speed}s` : `1.5s`};
  ${props => props.isRevealed ? (
    'transform: translate(0,0);'
   ) : (
    props.direction && (
      `transform: ${props.direction === 'right' ? 'translate(-200px,0)' : 'translate(200px,0)'};`
    )
   )};
`

export default function RevealOnScroll({
  scrollingElem = window,
  children,
  type = 'fade',
  direction = null,
  speed = 1.5
}) {
  const revealbox = useRef();
  const [isRevealed, setIsRevealed] = useState(false);
 
  useEffect(() => {
    const onScroll = () => {
      if (isInViewport(revealbox.current).isVisible) {
        setIsRevealed(true)
      }
    };
    scrollingElem.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  });

  return (
    <RevealerFade
      className={type}
      ref={revealbox}
      isRevealed={isRevealed}
      direction={direction}
      speed={speed}
    >
      { React.Children.count(children) > 1 ? (
        children.map((child, i) => (
          <div key={i.toString()}>
            { child }
          </div>
        ))
      ) : (
        <div>{children}</div>
      )}
    </RevealerFade>
  );
}
